import { Component, OnInit } from '@angular/core';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {
  RoutingSettingsApiService
} from '../../../services/api/settings/routing/routing-settings/routing-settings-api.service';
import {LoaderService} from '../../../services/common/loader-service/loader.service';

@Component({
  selector: 'global-routing-settings',
  templateUrl: './global-routing-settings.component.html',
  styleUrls: ['./global-routing-settings.component.scss']
})
export class GlobalRoutingSettingsComponent implements OnInit {

  isUnauthorized: boolean;
  routingSettings: any = {};

  enableRerouteGroupTypesOptions = [
    {name: 'original source'                 , value: false},
    {name: 'reroute peer connection'                       , value: true}
  ];

  constructor( private userPrivilege: UserPrivilegeService,
               private routingSettingsApiService: RoutingSettingsApiService,
               private loadService: LoaderService) { }

  ngOnInit(): void {
    this.loadService.showMainContainer();
    this.isUnauthorized = !this.userPrivilege.isAuthorized();

    this.routingSettingsApiService.getRoutingSettings().subscribe(routingSettings => {
      this.routingSettings = routingSettings;
      this.loadService.hideMainContainer();
    });
  }

  submit(): void {
    this.routingSettingsApiService.editRoutingSettings(this.routingSettings).subscribe();
  }

}
